import BrokerTabs from './broker-tabs';

export const CreateBrokerContainer = () => {
  return <BrokerTabs />;
};
